var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseGreen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  viewBox: "0 0 34 34"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h34v34H0z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 17,
  fill: "#007C76",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 2,
  d: "m9 9 16 16m0-16L9 25"
}))));
export default SvgCloseGreen;